import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./rootReducer";
import { clearAuthCache } from "../utils/authUtils";
import { createSessionMiddleware } from "./sessionMiddleware";

clearAuthCache();

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(createSessionMiddleware()),
});
